import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import NotFoundPage from 'pages/public/NotFoundPage';

import AirMilesLists from './AirMilesLists';
import AirMilesShow from './AirMilesShow';

const AirMiles = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="list" replace />} />
      <Route path="list" element={<AirMilesLists />} />
      <Route path="show/:id" element={<AirMilesShow />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default AirMiles;
